<template>
  <div class="MobileNumber">
    <el-row :gutter="20">
      <el-col :span="8">
        <!-- <el-select v-model="callingCode">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled">
          </el-option>
        </el-select> -->
        <el-input class="icon" v-model="callingCode" readonly />
      </el-col>
      <el-col :span="16">
        <el-input v-model="mobileNumber" maxlength="10" placeholder="Please input 10 digits" clearable></el-input>
      </el-col>
    </el-row>
    <div class="tips">
      <div>Make sure to enter your mobile number correctly.</div>
      <div>This cannot be corrected afterwards.</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MobileNumber",
    model: {
      prop: 'mobile',
      event: 'change'
    },
    props: ['mobile'],
    data() {

      return {
        options: [{
          value: '+63',
          label: '+63'
        },],
        callingCode: '+63',
        mobileNumber: '',
      };
    },

    watch: {
      mobile(newValue) {
        const data = newValue.substring(newValue.indexOf('-') + 1, newValue.length)
        this.mobileNumber = data.replace(/((?![0-9-]).)*/g,'')
      },
      callingCode() {
        this.$emit('change', `${this.callingCode}-${this.mobileNumber}`);
      },
      mobileNumber() {
        console.log(`${this.callingCode}-${this.mobileNumber}`)
        let emitData = this.mobileNumber === "" ? "" : `${this.callingCode}-${this.mobileNumber}`
        this.$emit('change', emitData);
      }
    },

    methods: {
      
    }
  }
</script>

<style lang="scss" scoped>
  .MobileNumber {
    ::v-deep .icon .el-input__inner {
      background: url('../../assets/pc/flag.png') no-repeat; //引入icon
      background-size: 22px 23px;  //这个是图片的大小&#xff0c;在这里不能直接设置width  height,设置宽高其实是select的宽高&#xff0c;图片可能会失真只设置宽度  高度auto也行
      background-position: 16px 13px; //在input中定位置  这两个参数是x  y坐标
      padding: 0 0 0 44px; //需要设置padding 把placeholder向右移
      box-sizing: border-box;
      font-size: 14px;
    }
    .tips{
      position: absolute;
      padding-top: 12px;
      line-height: normal;
      color: #919191;
      font-family: 'Nunito';
      font-size: 14px;
    }
  }
</style>